/**
 * 간편 설정이 아직 없는 계정의 처음 화면 언어 코드.
 *
 * 지금 보이는 화면 언어를 App.vue initLocale 과 같은 순서로 고른다: 일반 설정 창에서 고른 언어(쿠키
 * user_locale)가 있으면 그것, 없으면 브라우저 언어. 그 언어가 화면 언어 목록(locales.json)에 없으면
 * 영어로 시작한다(덴마크어 등 보류한 언어 포함, 10/26 결정). 예전엔 브라우저 언어만 봐서 설정 창에서
 * 스웨덴어를 골라도 첫 간편 설정·기본 점자가 브라우저 언어(한국어)로 정해졌다.
 *
 * @param {object} p
 * @param {string|null|undefined} p.cookieLocale 쿠키 user_locale
 * @param {string|null|undefined} p.navigatorLanguage navigator.language
 * @param {string[]} p.availableLocales 번역이 있는 화면 언어(i18n availableLocales) — 쿠키는 이 안에 있을 때만 쓴다
 * @param {string[]} p.listedCodes 화면 언어 목록(locales.json)의 코드
 * @returns {string}
 */
export function resolveInitLocaleCode({cookieLocale, navigatorLanguage, availableLocales, listedCodes}) {
    const shown = cookieLocale && availableLocales.includes(cookieLocale)
        ? cookieLocale
        : (navigatorLanguage || "").toLowerCase().substring(0, 2)
    return listedCodes.includes(shown) ? shown : "en"
}
